import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Field Directory Mappings',
  make: (fieldId: string) => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/fields/${fieldId}`,
      }),
  }),
});
